import { render, staticRenderFns } from "./AllCuratedSearches.vue?vue&type=template&id=f03d0306&scoped=true"
import script from "./AllCuratedSearches.vue?vue&type=script&lang=js"
export * from "./AllCuratedSearches.vue?vue&type=script&lang=js"
import style0 from "./AllCuratedSearches.vue?vue&type=style&index=0&id=f03d0306&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f03d0306",
  null
  
)

export default component.exports